import { useIntl } from "react-intl";

// Status marker for questionnaire rows in the admin list. Lives in its own
// file because both the manager list and the group editor's member list render
// it; the aria-label is translated rather than leaking the enum literal.

const LABEL_IDS: Record<string, { id: string; defaultMessage: string }> = {
  ACTIVE: { id: "admin.statusActive", defaultMessage: "Active" },
  INACTIVE: { id: "admin.statusInactive", defaultMessage: "Inactive" },
  DELETED: { id: "admin.statusDeleted", defaultMessage: "Deleted" },
};

export function StatusDot({ status }: { status: string }) {
  const intl = useIntl();
  const color =
    status === "ACTIVE" ? "bg-emerald-500" : status === "INACTIVE" ? "bg-ink/30" : "bg-red-400";
  const label = LABEL_IDS[status];
  const text = label ? intl.formatMessage(label) : status;
  return (
    <span
      role="img"
      className={`h-1.5 w-1.5 shrink-0 rounded-full ${color}`}
      aria-label={text}
      title={text}
    />
  );
}
